import repository from '@/utils/repository';

const resource = 'move';

export default {
    /**
     * Get help categories for FAQ
     * Uses SPC_GET_FAQ_CATEGORIES_LIST_INQ1 stored procedure
     */
    getHelpCategories: () => {
        return repository.get(`${resource}/CUS_Faq/categories`);
    }
};
